import React, { useCallback, useLayoutEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  DeleteProject,
  GetProject,
  PauseProject,
  ProjectSelectChange,
  ProjectStsChange,
} from "../api/projectapi";
import { ProjectCardInter } from "../interface/interface";
import { LoadingChange } from "../reducers/config";

type ReturnType = [
  never[] | ProjectCardInter[],
  (id: string) => void,
  (filter: string[], text: string) => void,
  (id: string) => void,
  (id: string) => void
];

type Props = {
  type: "prjt" | "mtup";
  filter: string;
  time: string;
};

const UseProjectCommon = ({ type, filter, time }: Props): ReturnType => {
  const dispatch = useDispatch();
  const [data, setData] = useState<never[] | ProjectCardInter[]>([]);

  const SpliceData = useCallback(
    (id: string) => {
      let clone = data.slice().filter(({ prjt_id }) => id !== prjt_id);
      setData(clone);
      dispatch(LoadingChange(false));
    },
    [data, dispatch]
  );

  const ProjectGet = useCallback(
    (text?: string) => {
      GetProject(type, filter, time, text).then(({ state, data, msg }) => {
        if (state) {
          setData(data);
        }
        dispatch(LoadingChange(false));
      });
    },
    [type, filter, time, dispatch]
  );

  const ProjectDelete = useCallback(
    (id: string) => {
      dispatch(LoadingChange(true));
      DeleteProject(id).then(({ state }) => {
        if (state) {
          SpliceData(id);
        } else {
          dispatch(LoadingChange(false));
        }
      });
    },
    [SpliceData, dispatch]
  );
  const ProjectPause = useCallback(
    (id: string) => {
      dispatch(LoadingChange(true));
      PauseProject(id).then(({ state }) => {
        if (state) {
          ProjectGet();
        } else {
          dispatch(LoadingChange(false));
        }
      });
    },
    [dispatch, ProjectGet]
  );
  const ChangeProjectSts = useCallback(
    (id: string) => {
      dispatch(LoadingChange(true));
      ProjectStsChange(id, "ing").then(({ state }) => {
        if (state) {
          ProjectGet();
        }
      });
    },
    [ProjectGet]
  );
  const SearchProject = useCallback(
    (filter: string[], text: string) => {
      ProjectGet(text);
    },
    [ProjectGet]
  );

  useLayoutEffect(() => {
    ProjectGet();
    return () => {};
  }, [ProjectGet]);
  return [data, ProjectDelete, SearchProject, ProjectPause, ChangeProjectSts];
};

export default UseProjectCommon;
